import { createError } from 'h3'
import { useCustomFetch, type CustomUseFetchOptions } from './custom-fetch'

export type ApiRequestOptions<T> = CustomUseFetchOptions<T>

export async function requestOrThrow<T>(path: string, options?: ApiRequestOptions<T>) {
  const { data, error } =
    options && Object.keys(options).length > 0
      ? await useCustomFetch<T>(path, options)
      : await useCustomFetch<T>(path)

  if (error.value) {
    throw createError({
      statusCode: error.value.statusCode,
      message: error.value.message,
      data: error.value.data,
      fatal: true,
    })
  }

  return data.value!
}
